import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { isHeapReady } from "utils/heapAnalytics";

function PageViewTracker() {
  const location = useLocation();
  const { pathname, search, hash } = location;
  const path = pathname + (hash?.replace(/^#\/?/, "") || "");

  // Handle Google Analytics/GTM tracking
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
      page: pathname + search,
    });
  }, [pathname, search]);

  // Handle Heap analytics
  useEffect(() => {
    if (isHeapReady("track")) {
      window.heap.track("Page View", {
        title: document.title,
        path: path + search,
        url: window.location.href,
      });
    }
  }, [path, search]);

  return null;
}

export default PageViewTracker;
